// extracted by mini-css-extract-plugin
module.exports = {"root":"Sidebar_root__1bEpE","logo":"Sidebar_logo__3cp2K","nav":"Sidebar_nav__3xbIZ"};